import React from 'react';
import TablePagination from '@mui/material/TablePagination';
import { SxProps, Theme } from '@mui/material/styles';
import { formatTablePaginationLabel } from '../../utils/pagination';

interface TableStylePaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
  sx?: SxProps<Theme>;
}

const TableStylePagination: React.FC<TableStylePaginationProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  sx,
}) => (
  <TablePagination
    component="div"
    count={count}
    page={Math.max(page - 1, 0)}
    onPageChange={(_event, newPage) => onPageChange(newPage + 1)}
    rowsPerPage={rowsPerPage}
    rowsPerPageOptions={[rowsPerPage]}
    labelDisplayedRows={formatTablePaginationLabel}
    sx={sx}
  />
);

export default TableStylePagination;
